import { useEffect } from 'react';
import { useDataSourceActions } from './useDataSourceActions';

export const useDataSourcesInit = (withoutLoadingAnimation = false) => {
  const { fetchDataSources } = useDataSourceActions();

  useEffect(() => {
    fetchDataSources(withoutLoadingAnimation);
  }, [fetchDataSources, withoutLoadingAnimation]);
};
